<template>
	<div>
		<b-row>
			<b-col md="12" class="mb-4">
				<h6>Null</h6>
				<permission-selectbox v-model="value1"/>
				<span>{{ value1 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Single Selected</h6>
				<permission-selectbox v-model="value2"/>
				<span>{{ value2 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Validate Error</h6>
				<permission-selectbox v-model="value3" :validateError="value3ValidateError"/>
				<span>{{ value3 }}</span>
			</b-col>
			<b-col cols="12">
				<b-button variant="primary" @click="change()">
					{{ $t('change') }}
				</b-button>
			</b-col>
		</b-row>
	</div>
</template>
<script>
	import PermissionSelectbox from "@/components/interactive-fields/PermissionSelectbox";

	export default {
		components: {
			PermissionSelectbox,
		},
		data() {
			return {
				value1: null,
				value2: 6,
				value3: 6,
				value3ValidateError: 'Validate Error is Working',
			}
		},
		methods: {
			change() {
				this.value2 = 4
				this.value3 = 4
				this.value3ValidateError = 'Error'
			}
		}
	};
</script>

